import { useProductsLocaleText } from '../../locale'

type SellingPoint = {
  description: string
}

export const useSellingPoints = (isPlant: boolean): SellingPoint[] => {
  const localiseText = useProductsLocaleText()

  if (isPlant) {
    return [
      {
        description: localiseText('usp.plants.next_day_delivery.description'),
      },
      {
        description: localiseText('usp.plants.expertly_selected.description'),
      },
      {
        description: localiseText(
          'usp.plants.healthy_and_thriving.description',
        ),
      },
      {
        description: localiseText(
          'usp.plants.perfect_gift_companion.description',
        ),
      },
    ]
  }

  return [
    {
      description: localiseText('usp.next_day_delivery.description'),
    },
    {
      description: localiseText('usp.hand_picked.description'),
    },
    {
      description: localiseText('usp.blooms_in_two_days.description'),
    },
    {
      description: localiseText('usp.freshness_guarantee.description'),
    },
    {
      description: localiseText('usp.perfect_gift_companion.description'),
    },
  ]
}
